<template>
  <fragment
    ><v-form
      ref="form"
      class="search-forms"
      @submit.prevent="filterCancellation"
    >
      <v-row>
        <v-col cols="12" md="3" sm="4">
          <BaseTextField
            tabindex="1"
            v-model="filter.pesquisar"
            append-icon="mdi-magnify"
            single-line
            hide-details
            placeholder="Pesquisar"
          ></BaseTextField>
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <v-menu
            offset-y
            ref="menu"
            v-model="menu"
            min-width="auto"
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                clearable
                hide-details
                label="Data Inicial"
                placeholder="dd/mm/aaaa"
                v-mask="'##/##/####'"
                v-model="filter.initDateView"
                v-on="on"
                v-bind="attrs"
                :append-icon="$config.icons.calendar"
              />
            </template>

            <v-date-picker
              locale="pt"
              v-model="filter.initDate"
              :active-picker.sync="activePicker"
              :header-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              @change="save"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <v-menu
            offset-y
            ref="menu2"
            v-model="menu2"
            min-width="auto"
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                clearable
                hide-details
                label="Data Final"
                placeholder="dd/mm/aaaa"
                v-mask="'##/##/####'"
                v-model="filter.endDateView"
                v-on="on"
                v-bind="attrs"
                :append-icon="$config.icons.calendar"
              />
            </template>

            <v-date-picker
              locale="pt"
              v-model="filter.endDate"
              :active-picker.sync="activePicker2"
              :header-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              @change="save2"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col class="d-flex justify-end">
          <BaseButton
            tabindex="4"
            variant="filter"
            class="button rounded-xxl"
            type="submit"
          >
            Filtrar
          </BaseButton>
        </v-col>
      </v-row>
    </v-form>

    <v-data-table
      class="rounded-lg"
      no-data-text="Não há registro de vendas por produto."
      loading-text="Buscando informações..."
      :headers="headers"
      :search="filter.pesquisar"
      :loading="cancellationLoading"
      :items="allCancellation.info"
      :items-per-page="10"
      :header-props="{
        class: 'rounded-t-lg',
        color: $config.dados.corinputs,
      }"
      :footer-props="{
        class: 'rounded-b-lg',
        itemsPerPageOptions: [10, 20, 50],
        itemsPerPageText: 'Vendas por página:',
      }"
    >
      <template v-slot:item.valor="{ item }">
        {{ item.valor | moeda }}
      </template>
    </v-data-table>
  </fragment>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import dayjs from "dayjs";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseButton from "@/components/forms/BaseButton.vue";

export default {
  name: "Cancellation",
  metaInfo: {
    title: "Relatório Sintético de Cancelamento | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Relatório Sintético de Cancelamento | ElevenTickets",
      },
    ],
  },
  props: {},
  components: { BaseTextField, BaseButton },
  data() {
    return {
      filter: {
        pesquisar: "",
        initDate: "",
        initDateView: "",
        endDate: "",
        endDateView: "",
      },
      search: "",
      dayjs: dayjs,
      activePicker: null,
      activePicker2: null,
      menu: false,
      menu2: false,
      headers: [
        {
          text: "Pedido",
          align: "center",
          value: "localizador",
          width: 120,
          sortable: false,
        },
        {
          text: "Mídia",
          align: "center",
          value: "midia",
          width: 120,
          sortable: false,
        },
        {
          text: "Data e Hora de Cancelamento",
          align: "center",
          value: "dthr_cancelamento",
          width: 260,
        },
        {
          text: "Usuário Cancelamento",
          align: "center",
          value: "usuario_cancelamento",
          width: 220,
        },
        {
          text: "Ingresso",
          align: "center",
          value: "dsc_produto",
          width: 240,
        },
        {
          text: "Nome Comprador",
          align: "center",
          value: "nome",
          width: 160,
        },
        {
          text: "CPF Comprador",
          align: "center",
          value: "documento",
          width: 130,
        },
        {
          text: "Valor",
          align: "center",
          value: "valor",
          width: 140,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "cancellation",
      "allCancellation",
      "cancellationLoading",
      "intervalDates",
    ]),
  },
  methods: {
    ...mapActions(["fetchCancellation"]),
    ...mapMutations(["setCancellationLoading", "setReportsFilter"]),
    filterCancellation() {
      let filter = {};

      if (this.filter.initDateView) {
        Object.assign(filter, {
          dthr_canc_ini: `${this.filter.initDate} 00:00`,
        });
      }

      if (this.filter.endDateView) {
        Object.assign(filter, {
          dthr_canc_fim: `${this.filter.endDate} 23:59`,
        });
      }

      Object.assign(filter, {
        producerId: this.storeSequencial,
        pesquisar: this.filter.pesquisar,
      });

      this.setReportsFilter(filter);
      this.fetchCancellation(filter);
    },
    save(date) {
      this.$refs.menu.save(date);
      this.filter.initDateView = dayjs(date).format("DD/MM/YYYY");
    },
    save2(date) {
      this.$refs.menu2.save(date);
      this.filter.endDateView = dayjs(date).format("DD/MM/YYYY");
    },
  },
  watch: {
    "$store.getters.storeSequencial": function () {
      this.filterCancellation();
    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = "MONTH"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "MONTH"));
    },
  },
  mounted() {
    this.fetchCancellation({ producerId: this.storeSequencial });
  },
  destroyed() {
    this.filter = {
      pesquisar: "",
      initDate: "",
      initDateView: "",
      endDate: "",
      endDateView: "",
    };
  },
};
</script>

<style scoped></style>
